module.exports = __webpack_public_path__ + "img/img17.9913fa2c.png";